export const ComingSoonWidget = () => {
  return (
    <div className="text-center flex flex-col items-center pt-10">
      <div className="text-2xl my-2 text-center">Usługa dostępna wkrótce</div>
      <img src="/assets/illustrations/cog.svg" alt="Illustration" />
    </div>
  )
}
